import { APP_ENV } from './env_config';

const API_URLS = {
  development: 'http://0.0.0.0:3002',
  staging: 'https://karmabox.almaconnect.com',
  production: 'https://karmabox.almaconnect.com',
};

const FRONTEND_URLS = {
  development: 'http://localhost:3000/',
  staging: 'https://staging-news.almaconnect.com/',
  production: 'https://newsapp.almaconnect.com/',
};

const PUBLIC_NEWS_FEED_URLS = {
  development: 'http://localhost:3001',
  staging: 'https://news.almaconnect.com',
  production: 'https://news.almaconnect.com',
};

const CRM_DIRECTORY_URLS = {
  development: 'http://localhost:5173/directory',
  staging: 'https://crm.almaconnect.com/directory',
  production: 'https://crm.almaconnect.com/directory',
};

const CRM_APP_URLS = {
  development: 'http://localhost:5173',
  staging: 'https://crm.almaconnect.com',
  production: 'https://crm.almaconnect.com',
};

const api_config = {
  API_URL:
    API_URLS[APP_ENV] ||
    API_URLS.development,
};

export default api_config;

export const FRONTEND_CONFIG = {
  WEB_URL:
    FRONTEND_URLS[APP_ENV] ||
    FRONTEND_URLS.development,
  PUBLIC_NEWS_FEED_URL:
    PUBLIC_NEWS_FEED_URLS[APP_ENV] ||
    PUBLIC_NEWS_FEED_URLS.development,
};

export const CRM_CONFIG = {
  APP_URL:
    CRM_APP_URLS[APP_ENV] ||
    CRM_APP_URLS.production,
  DIRECTORY_URL:
    CRM_DIRECTORY_URLS[APP_ENV] ||
    CRM_DIRECTORY_URLS.production,
  REPORTS_URL:
    `${CRM_APP_URLS[APP_ENV] || CRM_APP_URLS.production}/reports`,
  CREATE_REPORT_URL:
    `${CRM_APP_URLS[APP_ENV] || CRM_APP_URLS.production}/create_report`,
};
